"use strict";
const _ = require('lodash');
const prettyPrintVolume = articleViewModel => {
    if (articleViewModel.volume < 1) {
        return `${articleViewModel.volume * 1000}ml`;
    }
    return `${articleViewModel.volume}l`;
};
const getCaseUnitSizeAdjustment = articleViewModel => {
    if (articleViewModel.colliSize === 1 && articleViewModel.caseUnitSize > 1) {
        return articleViewModel.caseUnitSize;
    }
    return 1;
};
const prettyPrintWeight = articleViewModel => {
    const caseUnitSizeAdjustment = getCaseUnitSizeAdjustment(articleViewModel);
    if (articleViewModel.weight / caseUnitSizeAdjustment >= 1000) {
        return `${_.round(articleViewModel.weight / 1000 / caseUnitSizeAdjustment, 2)}kg`;
    }
    return `${_.round(articleViewModel.weight / caseUnitSizeAdjustment)}g`;
};
const weightUnits = ['kg', 'g', 'hg', 'mg'];
const isWeightSKU = myOrderedSKU => {
    if (_.includes(weightUnits, myOrderedSKU.name)) {
        return true;
    }
    return false;
};
const volumeUnits = ['l', 'ml', 'cl', 'dl', 'liter'];
const isVolumeSKU = myOrderedSKU => {
    if (_.includes(volumeUnits, myOrderedSKU.name)) {
        return true;
    }
    return false;
};
function getDisplaySKUSize(articleViewModel, myOrderedSKU) {
    if (!myOrderedSKU) {
        return articleViewModel.displayOrderUnitSize;
    }
    if (isWeightSKU(myOrderedSKU)) {
        return 'Viktvara';
    }
    if (isVolumeSKU(myOrderedSKU)) {
        return 'Volymvara';
    }
    const mainUnit = articleViewModel.stockKeepingUnits &&
        articleViewModel.stockKeepingUnits?.find(sku => sku.isMainUnit);
    if (mainUnit && mainUnit.name === 'kg') {
        return prettyPrintWeight({
            weight: myOrderedSKU.quantityOfMainUnitPerUnit * 1000,
        });
    }
    if (articleViewModel.volume > 0) {
        if (myOrderedSKU.quantityOfMainUnitPerUnit === 1) {
            return `${prettyPrintVolume(articleViewModel)}/${myOrderedSKU.name}`;
        }
        return `${myOrderedSKU.quantityOfMainUnitPerUnit}x${prettyPrintVolume(articleViewModel)}`;
    }
    if (articleViewModel.weight > 0) {
        if (myOrderedSKU.quantityOfMainUnitPerUnit === 1) {
            return `${prettyPrintWeight(articleViewModel)}/${myOrderedSKU.name}`;
        }
        return `${myOrderedSKU.quantityOfMainUnitPerUnit}x${prettyPrintWeight(articleViewModel)}`;
    }
    if (myOrderedSKU.quantityOfMainUnitPerUnit === 1) {
        return `Styckvara`;
    }
    return `${myOrderedSKU.quantityOfMainUnitPerUnit}/${myOrderedSKU.name}`;
}
module.exports = getDisplaySKUSize;
